<div class="container-fluid" *ngIf="isLoaded" [@fadeInAnimation]>
  <div class="row">
    <div class="col-lg-2 col-xl-3"></div>
    <div class="col-lg-8 col-xl-6">
      <div class="card mb-3">
        <div class="card-header">
          <fa-icon [icon]="['fas', 'info']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ 'label.ovrig-info-fran-instans' | translate:{ instans: instanceName } }}
        </div>
        <div class="card-body">
          <p class="h5 font-weight-bold">{{ 'label.' + (arende.arendeTyp.typ === 'kk' ? 'konkurs' : 'foretagsrekonstruktion') | translate }} {{ arende.galdenar.orgnr }} {{ arende.galdenar.namn }}</p>
          <p class="text-muted" *ngIf="!getOvrigInfo.length">{{ 'label.ingen-ovrig-info' | translate }}</p>
          <div class="table-responsive" *ngIf="getOvrigInfo.length">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">{{ 'label.beskrivning' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let i of getOvrigInfo | orderBy: 'sortering'">
                  <td>
                    <file-link *ngIf="i.fil && !i.arUrl" [file]="i.fil" [caption]="i.fil.beskrivning"></file-link>
                    <button class="btn btn-link btn-nowrap" (click)="openUrl(i.url)" *ngIf="i.arUrl" title="{{ i.urlBeskrivning }} ({{ i.url }})" style="outline: 0; outline-offset: 0"><fa-icon [icon]="['fas', 'link']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ i.urlBeskrivning }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
